// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth, db } from '../firebase'; // 1. Importar o 'db' do firebase
import { doc, getDoc, setDoc, serverTimestamp, updateDoc } from 'firebase/firestore'; // 2. Importar funções do Firestore
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [userProfile, setUserProfile] = useState(null); // 3. NOVO ESTADO para dados do perfil
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  function logout() {
    // Limpa os estados ao fazer logout
    setUserRole(null);
    setUserProfile(null);
    return signOut(auth);
  }

  // 4. NOVA FUNÇÃO para atualizar o perfil
  const updateUserProfile = async (dataToUpdate) => {
    if (!currentUser) return;
    const userRef = doc(db, 'users', currentUser.uid);
    try {
        await updateDoc(userRef, dataToUpdate);
        // Atualiza o estado local para refletir a mudança imediatamente
        setUserProfile(prevProfile => ({ ...prevProfile, ...dataToUpdate }));
    } catch (error) {
        console.error("Erro ao atualizar perfil do usuário:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      
      if (user) {
        try {
          const userRef = doc(db, 'users', user.uid);
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            // 5. Se o perfil já existe, carrega os dados para o estado
            setUserProfile(userSnap.data());
          } else {
            // Se for o primeiro login, cria o perfil
            const newProfileData = {
              uid: user.uid,
              nome: user.displayName,
              email: user.email,
              dataCriacao: serverTimestamp(),
              // Outros campos como telefone, endereço, etc., podem ser adicionados depois
            };
            await setDoc(userRef, newProfileData);
            setUserProfile(newProfileData); // Define o perfil recém-criado no estado
            console.log(`Novo perfil de usuário criado para ${user.email}`);
          }

          const idTokenResult = await user.getIdTokenResult(true); 
          setUserRole(idTokenResult.claims.role || null);
          console.log("Cargo do usuário verificado:", idTokenResult.claims.role);

        } catch (error) {
          console.error("Erro no processamento do usuário:", error);
          setUserRole(null);
          setUserProfile(null);
        }
      } else {
        setUserRole(null);
        setUserProfile(null);
      }
      
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    if (!loading && currentUser && userRole === 'admin') {
      if (window.location.pathname === '/dashboard') {
        navigate('/admin/dashboard');
      }
    }
  }, [currentUser, userRole, loading, navigate]);

  const value = {
    currentUser,
    userRole,
    userProfile, // 6. Disponibiliza o perfil
    updateUserProfile, // 7. Disponibiliza a função de atualização
    loading,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};